import { assignTokens, tokens } from '@sail/ui';
import { toIntent } from '@sail/engine';
import { color, font, shadow, border } from './tokens';
import { columnPaddingTablet, columnPaddingDesktop } from './tokens';
import { angleStyles, layoutStyles } from './styles';
import { buttonCustomization, checkboxCustomization, nativeCheckboxCustomization, linkCustomization, formFieldCustomization, textAreaCustomization, compositeFieldCustomization, textFieldCustomization, radioCustomization, nativeTextFieldCustomization, phoneNumberFieldCustomization, selectCustomization, tooltipCustomization } from './sailComponentCustomization';
export const helmTheme = toIntent([
    // Our customization of existing Sail tokens
    assignTokens(tokens, {
        border,
        color,
        font,
        shadow
    }),
    // Our customization of Sail components
    buttonCustomization,
    checkboxCustomization,
    nativeCheckboxCustomization,
    linkCustomization,
    formFieldCustomization,
    textAreaCustomization,
    compositeFieldCustomization,
    textFieldCustomization,
    radioCustomization,
    nativeTextFieldCustomization,
    phoneNumberFieldCustomization,
    selectCustomization,
    tooltipCustomization,
    // Helm Layout tokens and styles
    columnPaddingDesktop,
    columnPaddingTablet,
    layoutStyles,
    angleStyles
]);
// Export the function that reassigns the viewport tokens
export { setViewportTokens } from './tokens';

//# sourceMappingURL=helmTheme.js.map